/* Shared minimal building blocks for espace-client sub-pages */
import React from "react";

export function PageHeader({ eyebrow, title, italic, desc }) {
  return (
    <header className="mb-8">
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="font-serif-luxe text-3xl md:text-4xl leading-[1.1] mt-3">
        {title} {italic && <span className="italic gold-text">{italic}</span>}
      </h1>
      {desc && <p className="text-white/60 text-sm mt-3 max-w-2xl">{desc}</p>}
    </header>
  );
}

export function Field({ label, value, onChange, type = "text", placeholder = "", testid, required }) {
  return (
    <div>
      <label className="text-[11px] uppercase tracking-[0.22em] text-white/55 mb-2 block">{label}</label>
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        data-testid={testid}
        placeholder={placeholder}
        className="w-full bg-black/60 border border-[#DCB457]/25 px-4 py-3 text-sm text-white focus:border-[#DCB457] focus:outline-none transition"
      />
    </div>
  );
}

export function TextArea({ label, value, onChange, rows = 4, placeholder = "", testid }) {
  return (
    <div>
      <label className="text-[11px] uppercase tracking-[0.22em] text-white/55 mb-2 block">{label}</label>
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        data-testid={testid}
        placeholder={placeholder}
        className="w-full bg-black/60 border border-[#DCB457]/25 px-4 py-3 text-sm text-white focus:border-[#DCB457] focus:outline-none transition resize-y"
      />
    </div>
  );
}

export function Card({ children, className = "" }) {
  return <div className={`card-luxe p-6 md:p-8 ${className}`}>{children}</div>;
}

export function SaveBar({ saving, onSubmit, label = "Enregistrer", message }) {
  return (
    <div className="flex items-center justify-between gap-4 mt-6 flex-wrap">
      <p className="text-xs text-emerald-300 min-h-[1em]" data-testid="save-message">{message}</p>
      <button
        type="submit"
        onClick={onSubmit}
        disabled={saving}
        data-testid="save-btn"
        className="btn-gold disabled:opacity-60"
      >
        {saving ? "Enregistrement…" : label}
      </button>
    </div>
  );
}
